import { Form } from 'antd';
import { Fragment } from 'react';

export const ClientsViewForm = () => {
  return (
    <Fragment>
      <Form>hello</Form>
    </Fragment>
  );
};
